import React, { useEffect } from "react";
import AccountTemplate from "./account.template";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { storeToken, storeUser } from "../../reducers/app.reducer";
import { clearCart } from "../../reducers/cart.reducer";
import { useLocation } from "react-router-dom";

const AccountComponent = () => {
  const location = useLocation();
  const { userDetails } = useSelector((state) => state.app);
  const query = new URLSearchParams(location.search);
  const tabFromURL = query.get("tab");
  const [activeTab, setActiveTab] = useState(tabFromURL || "profile");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.app);

  const [showLogout, setShowLogout] = useState();

  const handleClickLogout = () => {
    setShowLogout(!showLogout);
  };

  const handleConfirmLogout = () => {
    dispatch(storeUser(null));
    dispatch(storeToken(null));
    dispatch(clearCart([]));
    setShowLogout(!showLogout);
    navigate("/");
  };

  useEffect(() => {
    const tabFromState = location.state?.openTab;
    if (tabFromState && 
      ["addresses", "orders"].includes(tabFromState)) {
      setActiveTab(tabFromState);
    }
  }, [location.state]);

  useEffect(() => {
    if (tabFromURL) {
      setActiveTab(tabFromURL);
    }
  }, [tabFromURL]);

  // login protection
  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user]);

  const templateData = {
    activeTab,
    user,
    userDetails,
    showLogout,
  };

  const templateEvents = {
    handleClickLogout,
    handleConfirmLogout,
    setActiveTab,
  };

  return (
    <AccountTemplate
      templateData={templateData}
      templateEvent={templateEvents}
    />
  );
};

export default AccountComponent;
